import React, { createContext, useContext, useState } from 'react';
import ConfirmationPopup from '../components/ConfirmationPopup.jsx';

const ConfirmationContext = createContext();

export const useConfirmation = () => {
  const context = useContext(ConfirmationContext);
  if (!context) {
    throw new Error('useConfirmation must be used within a ConfirmationProvider');
  }
  return context;
};

export const ConfirmationProvider = ({ children }) => {
  const [confirmationState, setConfirmationState] = useState({
    isOpen: false,
    title: '',
    message: '',
    confirmText: 'Tak',
    cancelText: 'Nie',
    style: 'normal',
    onConfirm: null,
    onCancel: null
  });

  const showConfirmation = ({
    title = 'Potwierdzenie',
    message = 'Czy na pewno chcesz kontynuować?',
    confirmText = 'Tak',
    cancelText = 'Nie',
    style = 'normal',
    onConfirm,
    onCancel
  }) => {
    return new Promise((resolve) => {
      setConfirmationState({
        isOpen: true,
        title,
        message,
        confirmText,
        cancelText,
        style,
        onConfirm: () => {
          setConfirmationState(prev => ({ ...prev, isOpen: false }));
          if (onConfirm) onConfirm();
          resolve(true);
        },
        onCancel: () => {
          setConfirmationState(prev => ({ ...prev, isOpen: false }));
          if (onCancel) onCancel();
          resolve(false);
        }
      });
    });
  };

  const hideConfirmation = () => {
    setConfirmationState(prev => ({ ...prev, isOpen: false }));
  };

  const value = {
    showConfirmation,
    hideConfirmation,
    confirmationState
  };

  return (
    <ConfirmationContext.Provider value={value}>
      {children}
      <ConfirmationPopup
        isOpen={confirmationState.isOpen}
        title={confirmationState.title}
        message={confirmationState.message}
        confirmText={confirmationState.confirmText}
        cancelText={confirmationState.cancelText}
        style={confirmationState.style}
        onConfirm={confirmationState.onConfirm}
        onCancel={confirmationState.onCancel}
      />
    </ConfirmationContext.Provider>
  );
};
